import { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./Profile.css";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [profile, setProfile] = useState({
    email: "",
    name: "",
    createdAt: "",
    referralCode: "",
    volunteerHours: 0,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (!user) {
      navigate("/Register");
      return;
    }

    if (!user.emailVerified) {
      setMessage("⚠️ Please verify your email to view your profile.");
      setLoading(false);
      return;
    }

    try {
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();

        setProfile({
          email: data.profile?.email || user.email,
          name: data.profile?.name || "",
          createdAt: data.profile?.createdAt
            ? new Date(
                data.profile.createdAt.toDate()
              ).toLocaleDateString()
            : "N/A",
          referralCode: data.profile?.referralCode || "N/A",
          volunteerHours: data.profile?.volunteerHours || 0,
        });
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
      setMessage("❌ Failed to load profile.");
    } finally {
      setLoading(false);
    }
  });

  return () => unsubscribe();
}, [navigate]);


  const handleSave = async () => {
    setSaving(true);
    setMessage("");

    try {
      const user = auth.currentUser;
      const docRef = doc(db, "users", user.uid);

      // Since name is no longer editable, this only updates fields in the future
      await updateDoc(docRef, {
        "profile.name": profile.name,
      });

      setMessage("✅ Profile updated successfully!");
    } catch (err) {
      console.error("Error saving profile:", err);
      setMessage("❌ Failed to save changes.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="profile-container">
        <h1 className="main-title">Loading your profile...</h1>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-card">
        <h1 className="main-title">My Profile</h1>
        <p className="subtitle">Manage your account details</p>

        {message && <p className="status-message">{message}</p>}

        <div className="input-group">
          <label>Email (read-only)</label>
          <input type="email" value={profile.email} readOnly />
        </div>

        <div className="input-group">
          <label>Name (read-only)</label>
          <input
            type="text"
            value={profile.name}
            readOnly
          />
        </div>

        <div className="input-group">
          <label>Account Created On</label>
          <input type="text" value={profile.createdAt} readOnly />
        </div>

        <div className="input-group">
          <label>Your Referral Code</label>
          <input type="text" value={profile.referralCode} readOnly />
        </div>

        <button
          className="cta-button-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default Profile;
